/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2024 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { useState } from 'react'

export const useSelectItems = ({
  excludeByProperty,
  mapSelectAllItems,
  items = []
}) => {
  const [allItemsSelected, setAllItemsSelect] = useState(false)
  const [itemIdsSelected, setItemIdsSelected] = useState([])
  const [itemsSelected, setItemsSelected] = useState([])
  const [numberSelected, setNumberSelected] = useState(0)
  const currentItems = excludeByProperty
    ? items.filter(item => !item[excludeByProperty])
    : items
  const getItemsByIds = (assetIds) => {
    return currentItems.filter(item => assetIds.includes(item.id))
  }
  const selectItem = id => {
    setAllItemsSelect(false)

    const index = itemIdsSelected.indexOf(id)
    const currentItemsSelected = index !== -1
      ? itemIdsSelected.filter(itemId => itemId !== id)
      : [...itemIdsSelected, id]
    const currentItems = getItemsByIds(currentItemsSelected)
    setItemIdsSelected(currentItemsSelected)
    setNumberSelected(currentItemsSelected.length)
    setItemsSelected(currentItems)

    return ({
      itemIds: currentItemsSelected,
      items: currentItems
    })
  }
  const selectOneItem = id => {
    const item = getItemsByIds([id])
    setAllItemsSelect(false)
    setItemIdsSelected([id])
    setItemsSelected(item)
    setNumberSelected(1)

    return ({
      itemIds: [id],
      item
    })
  }
  const clearSelectedItems = () => {
    setItemIdsSelected([])
    setAllItemsSelect(false)
    setNumberSelected(0)
  }
  const defaultMapSelectAllItems = (item) => {
    return item.id
  }
  const currentMapSelectAllItems = mapSelectAllItems || defaultMapSelectAllItems
  const selectAllItems = allItemsSelected => {
    if (allItemsSelected) {
      setItemIdsSelected(currentItems.map(currentMapSelectAllItems))
      setAllItemsSelect(true)
      setNumberSelected(currentItems.length)
      setItemsSelected(currentItems)
    } else {
      clearSelectedItems()
    }
  }

  return {
    allItemsSelected,
    itemIdsSelected,
    itemsSelected,
    clearSelectedItems,
    numberSelected,
    selectAllItems,
    selectItem,
    selectOneItem
  }
}
